import { HStack } from '@telescope/cassini-ui';
import { Reel } from './Reel';
import { AnimationOptions, REELS_COUNT } from 'features';
import { useEffect } from 'react';

type SlotMachineProps = {
  targets: number[]
  // @TODO: Slots as generic type 
  slots: any[]
  options?: {
    animation: AnimationOptions
  }
  onComplete?: () => void
  isAnimating?: boolean
  styles?: Record<string, any>
}

export const SlotMachine = ({ options, onComplete, isAnimating, targets, slots, styles } : SlotMachineProps) => {
  return (
    <HStack justify="center" spacing={1.5}>
      {Array.from({length: REELS_COUNT}, (_, i) => {
        const isLastReel = REELS_COUNT === i + 1;
        return <Reel key={i} items={slots} offset={i} 
                      target={targets[i]}
                      isAnimating={isAnimating}
                      options={options}
                      onComplete={isLastReel && onComplete? onComplete : null}
                      styles={{ ...styles?.slotMachine, ...styles?.reels[`reel${i+1}`] }} />
      })}
    </HStack>
  )
}